import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

import { PatternStruct, smallLangPattern } from './small-lang-pattern';

export const smallLangPatternValidator =
	(patterns: PatternStruct | Array<PatternStruct>): ValidatorFn =>
	(control: AbstractControl): ValidationErrors | null => {
		const { value } = control;
		return smallLangPattern(value, patterns);
	};
